import { get } from 'lodash';
import Cookie from 'js-cookie';
import {
  ELSTokenHelper,
  ELSURLHelper
} from '@els/els-ui-common-react';
import { AppLinkData } from '../../apis/eols-app-link/eols-app-link.dtos';
import {
  AppAction,
  Application
} from '../../apis/eols-app-link/eols-app-link.constants';
import {
  APP_LINK_COOKIE_EXPIRATION_DAYS,
  AppLinkCookie
} from './app-link-redirect.constants';
import { ServerConstants } from '../../components/app/server.constants';
import { ELSCommonConfig } from '../../components/els.components';

const getUpdatedAssignmentIdsFromAppLinkData = (appLinkData: AppLinkData): string[] | number[] => {
  return get(appLinkData, 'returnPostBody.assignmentIds', []);
};

export const shouldConnectAssignmentToSyllabusItem = (appLinkData: AppLinkData): boolean => {
  if (appLinkData.action !== AppAction.ASSIGNMENT_CREATE) {
    return false;
  }
  const assignmentIds = getUpdatedAssignmentIdsFromAppLinkData(appLinkData);
  const syllabusItemId = get(appLinkData, 'outPostBody.syllabusItemId', false);
  return Boolean(assignmentIds.length === 1 && syllabusItemId);
};

export const shouldShowAssignmentUpdatedToast = (appLinkData: AppLinkData): boolean => {
  // This is tech debt that should be cleaned up
  // EAQ should not be expecting us to treat preview actions like edits
  const isEAQEdit = appLinkData.targetApp === Application.EAQ && appLinkData.action === AppAction.ASSIGNMENT_PREVIEW;
  if (appLinkData.action === AppAction.ASSIGNMENT_EDIT || isEAQEdit) {
    const assignmentIds = get(appLinkData, 'returnPostBody.assignmentIds', []);
    return assignmentIds.length > 0;
  }
  return false;
};

export const addCookies = (linkId: string) => {

  const token = ELSTokenHelper.getToken();
  const domain = ServerConstants[ServerConstants.DataSource].cookiesDomain;

  Cookie.set(AppLinkCookie.X_LINK_ID, linkId, { path: '/', domain, expires: APP_LINK_COOKIE_EXPIRATION_DAYS });
  Cookie.set(AppLinkCookie.X_TOKEN, token, { path: '/', domain, expires: APP_LINK_COOKIE_EXPIRATION_DAYS });
};

type AppLinkLocation = Pick<Location, 'assign' | 'replace'>;

export const navigateToAppLinkUrl = (
  redirectUrl: string,
  replaceHistory = false,
  location: AppLinkLocation = window.location
) => {
  if (replaceHistory) {
    location.replace(redirectUrl);
    return;
  }

  location.assign(redirectUrl);
};

export const removeCookies = () => {
  const domain = ServerConstants[ELSCommonConfig.appProfile].cookiesDomain;
  Cookie.remove(AppLinkCookie.X_LINK_ID, { path: '/', domain });
  Cookie.remove(AppLinkCookie.X_TOKEN, { path: '/', domain });
};

export const pickCookies = (): {
  token: string;
  linkId: string;
} => {

  const tokenFromUrl = ELSURLHelper.getParameterByName('token');
  const linkIdFromUrl = ELSURLHelper.getParameterByName('linkId');

  if (tokenFromUrl && linkIdFromUrl) {
    removeCookies();

    return {
      token: tokenFromUrl,
      linkId: linkIdFromUrl
    };
  }

  const token = Cookie.get(AppLinkCookie.X_TOKEN);
  const linkId = Cookie.get(AppLinkCookie.X_LINK_ID);

  removeCookies();

  return { token, linkId };
};
